export default {
  cancelDialog: {
    title: '「{{studyName}}」をキャンセルしますか？',
    description:
      'シミュレーションは送信されません。メッシュは MeshGen に残り、削除されるものはありません。',
    alreadyProduced: '生成済み（保持されます）',
    openInMeshGen: 'MeshGen で開く',
    keepStudy: 'スタディを維持',
    confirmCancel: 'スタディをキャンセルしてメッシュを保持',
  },
  completionDialog: {
    eyebrow: 'シミュレーションを実行',
    title_one: '{{count}} 個の設計点をソルバーに送信しますか？',
    title_other: '{{count}} 個の設計点をソルバーに送信しますか？',
    description:
      'いつでもメッシュ作成に戻れますが、新しいシミュレーション実行には以下に添付されたメッシュが使用されます。',
    facesNamed: '{{cells}} · {{faces}} 命名済み',
    needsMeshing: 'メッシュが必要 — スキップされます',
    estimateLabel: '推定コスト · 時間',
    keepMeshing: 'メッシュ作成を続ける',
    runOnDps_one: '{{count}} 個の設計点でシミュレーションを実行',
    runOnDps_other: '{{count}} 個の設計点でシミュレーションを実行',
  },
  switcher: {
    ariaLabel: '設計点',
    moreCount: '他 {{count}} 件',
    nextPending: '次の保留中',
  },
  toasts: {
    cancelStudyPending:
      '研究のキャンセルはまだ利用できません — UI は準備済みで、バックエンド待ちです。',
    markDpPending:
      '設計点の完了マークはまだ利用できません — 次の保留中の設計点に進みます。',
  },
  journey: {
    ariaLabel: 'スタディの流れ',
    remeshTooltip_one: '{{count}} 個の設計点が再メッシュ待ち',
    remeshTooltip_other: '{{count}} 個の設計点が再メッシュ待ち',
    remeshBadge: '{{count}} 件再メッシュ',
    youAreHere: '現在ここ',
    skipped: 'スキップ',
    stepMeshSub: '健全性 + 設定',
    stepSimulateSub: 'パラメータ + 実行',
    stepResultsSub: '分析',
  },
  status: {
    notStarted: '未開始',
    meshing: 'メッシュ作成中',
    meshReady: 'メッシュ準備完了 — 面を命名',
    facesDone: '準備完了',
    failed: '失敗',
  },
  completionBar: {
    thisDp: 'この設計点',
    meshProduced: 'メッシュ生成済み',
    allFacesNamed: 'すべての面を命名済み',
    markDpComplete: '設計点を完了にする',
    studyProgress: 'スタディの進捗',
    completeAndRun: '完了してシミュレーションを実行',
  },
  progressList: {
    colDp: '設計点',
    colGeometry: 'ジオメトリ / バリアント',
    colMesh: 'メッシュ',
    colFaceNaming: '面の命名',
    colStatus: 'ステータス',
    colAction: '操作',
    failedInMesh: 'メッシュ作成に失敗',
    namingInProgress: '命名中',
    facesNamed: '{{faces}} 命名済み',
    allNamed: 'すべて命名済み',
    currentlyOpen: '現在開いています',
    reopen: '再度開く',
    openInMeshGen: 'MeshGen で開く',
    viewInMeshGen: 'MeshGen で表示',
  },
  resumeCard: {
    ariaLabel: 'メッシュ作成を再開 — {{studyName}}',
    eyebrow: 'メッシュ作成を再開',
    paused: '{{ago}}に一時停止',
    expiresIn: '{{time}}後に期限切れ',
    remaining_one: '{{total}} 個中 {{remaining}} 個のジオメトリが残っています',
    remaining_other:
      '{{total}} 個中 {{remaining}} 個のジオメトリが残っています',
    autoQueue:
      'メッシュ作成が完了するとシミュレーションが自動的にキューに追加されます',
    resumeNextPending: '次の保留中を再開',
    cancelStudy: 'スタディをキャンセル…',
  },
  tree: {
    removeFromRun: '実行からメッシュを削除',
    addToRun: '実行にメッシュを追加',
    collapse: '折りたたむ',
    expand: '展開',
    remesh: '再メッシュ',
    mesh: 'メッシュ',
    view: '表示',
    review: '確認',
    otherSimType: '別の解析種別',
    notMeshedYet: 'まだメッシュ化されていません',
    meshLabel: 'メッシュ',
    refinementLabel: '細分化',
  },
  contextBanner: {
    returnToStudy: 'スタディに戻る',
    studyMode: 'スタディモード',
    geometryOf: 'ジオメトリ {{total}} 個中 {{index}} 個目',
    nameFaceToCommit: '1 つの面を命名してコミット',
    ready: '準備完了',
  },
  draftChrome: {
    geometryNotStarted: '未メッシュ化',
    geometryLoading: '確認中…',
    geometryProcessing: '準備中',
    geometryAwaitingApproval: '承認待ち',
    geometryError: 'メッシュ化不可',
    geometryMeshing: 'メッシュ作成中',
    geometryCompleted: '準備完了',
    geometryFailed: '失敗',
    fallbackStudyTitle: 'スタディ',
    backToStudy: 'スタディに戻る',
    meshedProgress: '{{total}} 個中 {{done}} 個メッシュ化済み',
    geomLabel: 'ジオメトリ {{index}} · {{status}}',
    allMeshed: 'すべてのジオメトリがメッシュ化されました。',
    meshAllToContinue:
      '続行するにはすべてのジオメトリをメッシュ化してください。',
    continueToSimulate: 'シミュレートに進む',
    waitForPreparation_one:
      '準備中または要確認のジオメトリ {{count}} 個を待っています。',
    waitForPreparation_other:
      '準備中または要確認のジオメトリ {{count}} 個を待っています。',
  },
  studyChrome: {
    loadingContext: 'スタディコンテキストを読み込み中…',
    errorContext:
      'この設計点のスタディコンテキストを読み込めませんでした — ワークスペースは使用できますが、スタディの枠組みは非表示です。',
    returnToStudy: 'スタディに戻る',
  },
  timeoutCard: {
    ariaLabel: 'メッシュ作成セッションがタイムアウトしました',
    title: 'メッシュ作成セッションがタイムアウトしました',
    badge: '失敗 · 期限切れ',
    body_one:
      'このスタディは「メッシュ待ち」の状態で 7 日間経過したため、一時停止しました。完了した {{count}} 個のメッシュは MeshGen に安全に保存されています。それらをもとに新しいスタディを開始して続きから再開できます — メッシュ取り込みスタディは、すでに確定したメッシュを再利用します。',
    body_other:
      'このスタディは「メッシュ待ち」の状態で 7 日間経過したため、一時停止しました。完了した {{count}} 個のメッシュは MeshGen に安全に保存されています。それらをもとに新しいスタディを開始して続きから再開できます — メッシュ取り込みスタディは、すでに確定したメッシュを再利用します。',
    startNewStudy: 'これらのメッシュから新しいスタディを開始',
    viewFinishedMeshes: '完了したメッシュを表示',
    archiveStudy: 'スタディをアーカイブ',
  },
} as const;
